import React, { useRef, useState } from 'react';

export default function ClanWarBattle({ match, clanId }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [score, setScore] = useState(null);
  const retry = useRef(null);
  const active = match.status === 'active' && new Date(match.end_time) > new Date();
  const attack = async () => {
    if (busy || !active) return;
    setBusy(true);
    const batch = retry.current || { requestId: window.crypto.randomUUID(), clicks: 1 };
    retry.current = batch;
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/wars/match/${match.id}/clicks`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(batch), signal: AbortSignal.timeout(10000),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error);
      retry.current = null; setScore(data); setError('');
    } catch (error) { setError(error.message); }
    finally { setBusy(false); }
  };
  const ownWinner = String(match.winner_id) === String(clanId);
  return <section className="war-match">
    <span className="eyebrow">РАУНД {match.round} · {active ? 'БОЙ ИДЁТ' : 'ЗАВЕРШЁН'}</span>
    <div className="war-score"><div><span>{match.team1_name}</span><strong>{Math.max(Number(match.team1_clicks), Number(score?.team1_clicks || 0)).toLocaleString('ru-RU')}</strong></div><b>VS</b><div><span>{match.team2_name || 'Без соперника'}</span><strong>{Math.max(Number(match.team2_clicks), Number(score?.team2_clicks || 0)).toLocaleString('ru-RU')}</strong></div></div>
    {active ? <><p>До {new Date(match.end_time).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}</p><button className="game-primary" disabled={busy} onClick={attack}>{busy ? 'Сохраняем…' : retry.current ? 'Повторить сохранение' : 'Ударить за клан'}</button></> : <p>{ownWinner ? 'Победа вашего клана!' : 'Бой завершён'} · Результат сохранён</p>}
    {error && <p role="status">{error}</p>}
  </section>;
}
